import { EventHeaderTableColumnAction } from 'src/components/Events/EventHeader';
import { useMatchMedia } from 'src/hooks/useMatchMedia';
import { CustomListingColumn } from 'src/utils/columns/inventory/inventoryCustomColumnUtils.types';
import { SectionType } from 'src/utils/types/sectionType';

import { InventoryEventTabs } from '../../../InventoryEventTabs';
import { useInventoryEventLocalContext } from '../../InventoryEventLocalContext';

export const EventContentAction = () => {
  const { activeTab } = useInventoryEventLocalContext();
  const isMobile = useMatchMedia('mobile');

  if (
    (activeTab === InventoryEventTabs.Info ||
      activeTab === InventoryEventTabs.ManualPricing) &&
    !isMobile
  ) {
    return (
      <EventHeaderTableColumnAction<CustomListingColumn>
        sectionType={SectionType.Listings}
      />
    );
  }
  return null;
};
